// import React, { useMemo, useState } from "react";
// import { useTable } from "react-table";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   IconButton,
//   Collapse,
//   Box,
//   styled
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// // Create a styled TableRow component
// const CustomTableRow = styled(TableRow)(({ theme }) => ({
//   color: 'inherit',
//   display: 'flex',
//   verticalAlign: 'middle',
//   outline: 0
// }));


// // Sample Data
// const data = [
//   {
//     Message: [
//       {
//         IdRequest: 170,
//         Title: "dfg",
//         Description: "dfg",
//         companyName: "Pagac, Hirthe and Hilpert",
//         CategoryName: "Offerta",
//         TypeName: "Finanza Agevolata",
//         PublishDate: "2025-02-28",
//       },
//     ],
//     CreationUser: "Stefano asd",
//   },
//   {
//     Message: [
//       {
//         IdRequest: 171,
//         Title: "asd",
//         Description: "asd",
//         companyName: "Pagac, Hirthe and Hilpert",
//         CategoryName: "Offerta",
//         TypeName: "Finanza Agevolata",
//         PublishDate: "2025-03-02",
//       },
//     ],
//     CreationUser: "Stefano asd",
//   },
//   {
//     Message: [
//       {
//         IdRequest: 155,
//         Title: "asd",
//         Description: "asd",
//         companyName: "Pagac, Hirthe and Hilpert",
//         CategoryName: "Offerta",
//         TypeName: "Finanza Agevolata",
//         PublishDate: "2025-02-22",
//       },
//     ],
//     CreationUser: "Stefano asd",
//   },
// ];

// // DataTable component
// const DataTable = () => {
//   // Define the columns inside the component (useMemo inside the component)
//   const columns = useMemo(
//     () => [
//       {
//         Header: "Creation User",
//         accessor: "CreationUser",
//       },
//       {
//         Header: "Message List",
//         accessor: "Message",
//         Cell: ({ row }) => <MessageCollapse row={row} />, // Rendering collapsible message details
//       },
//     ],
//     []
//   );

//   // Initialize the table instance using React Table hooks
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     rows,
//     prepareRow,
//   } = useTable({ columns, data });

//   return (
//     <TableContainer sx={{ maxWidth: "100%" }}>
//       <Table {...getTableProps()}>
//         <TableHead>
//           {headerGroups.map((headerGroup) => (
//             <TableRow {...headerGroup.getHeaderGroupProps()}>
//               {headerGroup.headers.map((column) => (
//                 <TableCell {...column.getHeaderProps()}>{column.render("Header")}</TableCell>
//               ))}
//             </TableRow>
//           ))}
//         </TableHead>
//         <TableBody {...getTableBodyProps()}>
//           {rows.map((row) => {
//             prepareRow(row);
//             return (
//               <TableRow {...row.getRowProps()}>
//                 {row.cells.map((cell) => (
//                   <TableCell {...cell.getCellProps()}>{cell.render("Cell")}</TableCell>
//                 ))}
//               </TableRow>
//             );
//           })}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };

// // MessageCollapse component for handling the collapsible message details
// const MessageCollapse = ({ row }) => {
//   const [open, setOpen] = useState(false);

//   const toggleOpen = () => {
//     setOpen(!open);
//   };

//   return (
//     <Box>
//       <IconButton onClick={toggleOpen}>
//         <ExpandMoreIcon />
//       </IconButton>
//       <Collapse in={open}>
//         {row.values.Message.map((msg, index) => (
//           <Box sx={{ marginTop: 2 }}>
//           <TableContainer sx={{ boxShadow: "none", width: "100%" }}>
//             <Table sx={{ minWidth: "650px",display:"block" }}>
//               <TableHead>
//                 <TableRow>
//                   <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>IdRequest</TableCell>
//                   <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Title</TableCell>
//                   <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Description</TableCell>
//                   <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Company Name</TableCell>
//                   <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Category</TableCell>
//                   <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Type</TableCell>
//                   <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Publish Date</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 <TableRow>
//                   <TableCell sx={{ textAlign: "center" }}>{msg.IdRequest}</TableCell>
//                   <TableCell sx={{ textAlign: "center" }}>{msg.Title}</TableCell>
//                   <TableCell sx={{ textAlign: "center" }}>{msg.Description}</TableCell>
//                   <TableCell sx={{ textAlign: "center" }}>{msg.companyName}</TableCell>
//                   <TableCell sx={{ textAlign: "center" }}>{msg.CategoryName}</TableCell>
//                   <TableCell sx={{ textAlign: "center" }}>{msg.TypeName}</TableCell>
//                   <TableCell sx={{ textAlign: "center" }}>{msg.PublishDate}</TableCell>
//                 </TableRow>
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Box>
        
//         ))}
//       </Collapse>
//     </Box>
//   );
// };

// export default DataTable;



import React, { useState, useEffect, useMemo } from "react";
import DataTable from "./dataTable"; // Import the DataTable component
import MessageCollapse from "./MessageCollapse";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";

import { url, urlLive } from "../../constant";

import dayjs from 'dayjs';
import 'dayjs/locale/en-gb'; // Import the locale for British English


const ParentComponent = () => {

  const [messages, setMessages] = useState([]);

  const [loading, setLoading] = useState(false);  // Loading state for data
  const [formLoading, setFormLoading] = useState(false);  // Loading state for form submission

  // State for error handling in case of fetch failure
  const [error, setError] = useState("");
  // State to handle tab selection
    const [selectedTab, setSelectedTab] = useState(0);

  // Fetch data for request types using useEffect
    useEffect(() => {
  
      setLoading(true);  // Show loader while fetching data
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
  
      fetch(`${url}auth/get-messages`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.message === "Messages fetched successfully.") {
            setMessages(result.messages); // Store the request types in state
          } else {
            setError("Failed to fetch data.");
          }
        })
        .catch((error) => {
          setError("Error fetching data");
          console.error(error);
        })
        .finally(() => {
          setLoading(false); // Data fetch completed
        });
  
    }, []);


  // // Sample data to pass to the DataTable
  // const tableData = useMemo(() => ({
  //   columns: [
  //     {
  //       Header: "Creation User",
  //       accessor: "CreationUser",
  //     },
  //     {
  //       Header: "Messages",
  //       accessor: "Message",
  //       Cell: ({ row }) => <MessageCollapse row={row} />, // Custom cell component for collapsible message
  //     },
  //   ],
  //   rows: [
  //     {
  //       CreationUser: "Stefano asd",
  //       Message: [
  //         {
  //           IdRequest: 170,
  //           Title: "dfg",
  //           Description: "dfg",
  //           companyName: "Pagac, Hirthe and Hilpert",
  //           CategoryName: "Offerta",
  //           TypeName: "Finanza Agevolata",
  //           PublishDate: "2025-02-28",
  //         },
  //       ],
  //     },
  //     {
  //       CreationUser: "Stefano asd",
  //       Message: [
  //         {
  //           IdRequest: 171,
  //           Title: "asd",
  //           Description: "asd",
  //           companyName: "Pagac, Hirthe and Hilpert",
  //           CategoryName: "Offerta",
  //           TypeName: "Finanza Agevolata",
  //           PublishDate: "2025-03-02",
  //         },
  //       ],
  //     },
  //     {
  //       CreationUser: "Stefano asd",
  //       Message: [
  //         {
  //           IdRequest: 155,
  //           Title: "asd",
  //           Description: "asd",
  //           companyName: "Pagac, Hirthe and Hilpert",
  //           CategoryName: "Offerta",
  //           TypeName: "Finanza Agevolata",
  //           PublishDate: "2025-02-22",
  //         },
  //       ],
  //     },
  //   ],
  // }), []);



  // Transform the "messages" into the "rows" structure
  
  const rows = useMemo(() => {
    return messages.map(message => {
      // Parse the ObjectMessage string to get the message details
      const parsedMessages = JSON.parse(message.ObjectMessage);

      // Return the row structure
      return {
        CreationUser: message.CreationUserName,
        Message: parsedMessages, // Attach the parsed message data here
      };
    });
  }, [messages]);


  const tableData = {
    columns: [
      {
        // Header: "Creation User",
        Header: "Utente",
        accessor: "CreationUser",
      },
      {
        // Header: "Object Messages",
        Header: "Messaggio",
        accessor: "Message",
        Cell: ({ row }) => <MessageCollapse row={row} />,
      },
    ], rows
  };
 

  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const entriesPerPage = { defaultValue: 10, entries: [5, 10, 15, 20,25,50] };

  const pagination = {
    totalEntries: tableData.rows.length,
    showTotalEntries: true,
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <DashboardLayout>
    <DashboardNavbar />

    {/* Loader Component */}
    <Backdrop open={loading || formLoading} sx={{ color: '#fff', zIndex: 1000 }}>
        <CircularProgress color="inherit" />
    </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  // bgColor="info"  
                  bgColor="#183759"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    {/* Messages */}
                    Messaggi
                  </MDTypography>
                </MDBox>

                <Box sx={{ width: '100%' }}>
                  <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="basic tabs example"
                  >
                    {/* <Tab label="List Messages" /> */}
                    <Tab label="Elenca messaggi" />
                    {/* <Tab label="Add Request Type" /> */}

                    {/* <Tab label="Elenco Tipologia Richieste" />
                  <Tab label="Nuova Tipologia Richiesta" /> */}

                  </Tabs>

                  {/* Tab Content for List Request Types */}
                  {selectedTab === 0 && (
                    <MDBox pt={3}>
                      {/* <h1>DataTable with Collapsible Rows</h1> */}
                      <DataTable
                        entriesPerPage={entriesPerPage}
                        canSearch={false}
                        // showTotalEntries={pagination.showTotalEntries}
                        table={tableData}
                        pagination={pagination}

                        isSorted={true}
                        noEndBorder={false}
                        currentPageIndex={currentPageIndex}
                        setCurrentPageIndex={setCurrentPageIndex}
                      />
                    </MDBox>
                  )}

                </Box>

              </Card>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

    <Footer />

    </DashboardLayout>
  );
};

export default ParentComponent;


